module.exports = "<img backgroundImage type=\"bonus2\" [src]=\"imgPath\">\n"